import React from 'react';
import Section from '@components/Section';
import styles from './Social.module.scss';
import logoIcons from '@components/Icons/SocialIcons';
import analytics from '@support/analytics';

const platforms = {
  facebook: 'facebookURL',
  linkedin: 'linkedinURL',
  instagram: 'instagramURL',
  twitter: 'twitterURL',
  github: 'githubURL',
  angellist: 'angellistURL',
  soundcloud: 'soundcloudURL',
  quora: 'quoraURL',
  youtube: 'youtubeURL',
  vimeo: 'vimeoURL',
  aboutme: 'aboutmeURL',
  tumblr: 'tumblrURL',
  pinterest: 'pinterestURL',
  slideshare: 'slideshareURL',
  reddit: 'redditURL',
  flickr: 'flickrURL',
  foursquare: 'foursquareURL',
  hackernews: 'hackernewsURL',
};

function handleClick(contact) {
  analytics.track('Contact Social Tapped', { contactId: contact.objectID });
}

export function buildSocial(contact) {
  const social = [];

  for (const [platform, key] of Object.entries(platforms)) {
    if (!contact[key]) {
      continue;
    }

    social.push({
      platform,
      url: contact[key],
    });
  }

  return social;
}

export default function Social({ contact, underline = true }) {
  const social = buildSocial(contact);

  if (social.length === 0) {
    return null;
  }

  return (
    <Section>
      <Section.Title underline={underline}>Social</Section.Title>
      <div className={styles.items}>
        {social.map((item, i) => {
          const LogoIcon = logoIcons[item.platform];

          return (
            <a
              onClick={() => handleClick(contact)}
              className={styles.item}
              key={i}
              href={item.url}
              target="_blank"
            >
              <LogoIcon className={styles.logo} />
            </a>
          );
        })}
      </div>
    </Section>
  );
}
